module.exports = __webpack_public_path__ + "static/habits-mobile-8de8a05a1917a084354f96e1df724c81.webp";